import * as React from 'react';
import {
  StyleSheet,
  Pressable,
  View,
  Platform,
  Dimensions
} from 'react-native';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import { Space, Card, CheckBox, Text } from 'secullum-react-native-ui';
import { getTheme } from '../../shared/modules/layout';
import { getPeriodoFormatado } from '../containers/AssinaturaDigitalCartaoPontoContainer';
import {
  AssinaturaDigitalCartaoPontoDados,
  AssinaturaDigitalCartaoPontoStatus
} from '../modules/types';

interface Props {
  assinaturaDigitalCartaoPonto: AssinaturaDigitalCartaoPontoDados;
  iconeStatus: string;
  corIconeStatus: string;
  iconeStatusGerente?: string;
  corIconeStatusGerente?: string;
  nativeID?: string;
  checked: boolean;
  exibirSeparador: boolean;
  onNavigate: () => void;
  onChecked: () => void;
  gerente?: boolean;
}

class AssinaturaDigitalCartaoPontoLinha extends React.Component<Props> {
  static defaultProps = {
    checked: false
  };

  render() {
    const {
      assinaturaDigitalCartaoPonto,
      corIconeStatus,
      iconeStatus,
      iconeStatusGerente,
      corIconeStatusGerente,
      exibirSeparador,
      checked,
      onChecked,
      nativeID,
      gerente
    } = this.props;

    const webDesktop =
      Platform.OS === 'web' && Dimensions.get('window').width >= 900;

    const estado = gerente
      ? assinaturaDigitalCartaoPonto.estadoGerente
      : assinaturaDigitalCartaoPonto.estado;

    const renderCheckbox = () => {
      if (estado !== AssinaturaDigitalCartaoPontoStatus.NaoRespondido) {
        return <View style={styles.placeholderCheckbox} />;
      }
      return (
        <CheckBox
          nativeID={`assinatura-digital-cartao-ponto-checkbox-${assinaturaDigitalCartaoPonto.id}`}
          value={checked}
          onChange={onChecked}
        />
      );
    };

    const renderInfo = () => {
      const periodo = getPeriodoFormatado(assinaturaDigitalCartaoPonto);

      if (webDesktop) {
        return (
          <>
            <Text bold flex={1} size={14} style={styles.linhaText}>
              {assinaturaDigitalCartaoPonto.descricao}
            </Text>
            {gerente && (
              <Text bold flex={1} size={14} style={styles.linhaText}>
                {assinaturaDigitalCartaoPonto.funcionarioNome}
              </Text>
            )}
            <Text bold flex={0.5} size={14} style={styles.linhaText}>
              {periodo}
            </Text>
          </>
        );
      }

      return (
        <Text bold flex={1} size={14} style={styles.linhaText}>
          {assinaturaDigitalCartaoPonto.descricao}
          {'\n'}
          {periodo}
          {gerente && (
            <>
              {'\n'}
              {gerente && assinaturaDigitalCartaoPonto.funcionarioNome}
            </>
          )}
        </Text>
      );
    };

    const renderStatusIcons = () => {
      return (
        <>
          {gerente && (
            <FontAwesome
              testID={iconeStatusGerente}
              name={iconeStatusGerente!}
              color={corIconeStatusGerente}
              size={20}
              style={[
                styles.icon,
                {
                  flex: 0.2,
                  minWidth: 65
                }
              ]}
            />
          )}
          {(!gerente || webDesktop) && (
            <FontAwesome
              testID={iconeStatus}
              name={iconeStatus}
              color={corIconeStatus}
              size={20}
              style={[
                styles.icon,
                {
                  flex: 0.2,
                  minWidth: gerente ? 85 : 50
                }
              ]}
            />
          )}
        </>
      );
    };

    return (
      <>
        {exibirSeparador && <Space height={10} />}
        <Card>
          <Card.Section nativeID={nativeID}>
            <Pressable
              style={({ pressed }) => [
                { opacity: pressed ? 0.7 : 1 },
                styles.linhaTouchable
              ]}
              onPress={() => this.props.onNavigate()}
            >
              {renderCheckbox()}

              <Text
                bold
                flex={webDesktop ? 0.2 : 0.4}
                size={14}
                style={styles.linhaText}
              >
                {assinaturaDigitalCartaoPonto.assinaturaDigitalCartaoPontoId}
              </Text>

              {renderInfo()}
              {renderStatusIcons()}
            </Pressable>
          </Card.Section>
        </Card>
      </>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  linhaTouchable: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1
  },
  placeholderCheckbox: {
    width: 24
  },
  linhaText: {
    paddingRight: 5,
    ...(Platform.OS === 'web' ? { wordBreak: 'break-all' } : {}),
    color: theme.textColor1
  },
  icon: {
    paddingRight: 5,
    textAlign: 'center'
  }
});

export default AssinaturaDigitalCartaoPontoLinha;
